export const IP_MARKETPLACE_LIST_REQUEST = "IP_MARKETPLACE_LIST_REQUEST";
export const IP_MARKETPLACE_LIST_SUCCESS = "IP_MARKETPLACE_LIST_SUCCESS";
export const IP_MARKETPLACE_LIST_ERROR = "IP_MARKETPLACE_LIST_ERROR";
